import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import {
  provideCastingHub,
  provideEventsApi,
  provideVideosApi,
} from '@health-house/shared/api';
import {
  provideApiEndpointsFromEnvironment,
  provideConfigurationLoader,
} from '@shareview-health/configuration';
import {
  provideAuthenticationFromEnvironment,
  SharedAuthenticationModule,
} from '@shareview/shared/authentication';
import { appRoutes } from './app.routes';
import { provideAppState } from './app.state';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    // provideConfigurationLoader(),
    // provideAuthenticationFromEnvironment(),
    // provideApiEndpointsFromEnvironment(),
    importProvidersFrom(SharedAuthenticationModule.forRoot(), MatDialogModule),
    provideAppState(),
    provideCastingHub('https://cast-sessions.services.health-house.shareview.dev/hubs/cast-session'),
    provideEventsApi('https://cast-sessions.services.health-house.shareview.dev'),
    provideVideosApi('https://cast-sessions.services.health-house.shareview.dev'),
  ],
};
